import { useContext } from 'react'

import PhotoCameraFrontOutlinedIcon from '@mui/icons-material/PhotoCameraFrontOutlined'

import { PassContext } from "../../../pass-context"
import PopupEditor from '../../popup-editor'
import dataSelector from '../../data-selector'

const ThumbnailImage = () => {
  const { template, variables } = useContext(PassContext)

  const path = "meta.images.thumbnail"
  const image = dataSelector({ template, variables, path })

  if (image) return (
    <PopupEditor title="Thumbnail Image" path="meta.images.thumbnail">
      <img src={image} className="thumbnail" />
      <div className="thumbnail editable" />
    </PopupEditor>
  )
  else return (
    <PopupEditor title="Thumbnail Image" path="meta.images.thumbnail">
      <PhotoCameraFrontOutlinedIcon className='editIcon' style={{ position: "absolute", top: 120, right: 10, color: "black", fontSize: 40 }} />
    </PopupEditor>
  )
}

export default ThumbnailImage